import { queryParse, queryStringify } from '@lsfe/tools';
// 对参数中的字符串进行trim
const trimParams = (params = {}) => {
    if (params) {
        Object.entries(params).forEach(([k, v]) => {
            if (typeof v === 'object') {
                trimParams(v);
            } else if (typeof v === 'string') {
                params[k] = v.trim();
            }
        });
    }
};

const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};

function parseRequestOptions(options) {
    let headers = {};
    if (options.headers) {
        headers = options.headers;
        delete options.headers;
    }
    const opts = {
        credentials: 'same-origin',
        headers: {
            ...defaultHeaders,
            ...headers
        }
    };
    return opts;
}

// 处理基本的错误, 如500, 404等等
function filterStatus(res, url, responseTime) {
    if (!res) {
        // res 不存在，主要是因为别浏览器强制挂掉了请求，比如频繁的切换页面，这个需要去掉
        return Promise.reject({
            __status__: 'canceled'
        });
    }
    if (res.status >= 200 && res.status < 300) {
        return res;
    }

    return res
        .json()
        .then(data => {
            // 有一些500，但是有可读错误信息的时候，先取出错误信息
            const e = new Error((data && data.msg) || res.statusText);
            if (data && data.code) {
                e.code = data.code;
            }
            return e;
        })
        .catch(() => {
            return new Error(res.statusText);
        })
        .then(err => {
            err.type = 'http';
            err.status = res.status;
            throw err;
        });
}

// 解析为json格式
export function parseJSON(res, url, responseTime) {
    if (!res) {
        return Promise.reject({
            __status__: 'canceled'
        });
    }
    return res
        .json()
        .then(res => {
            if (res) {
                sendCatApi(url, res.code, responseTime);
            }
            return res;
        })
        .catch(err => {
            if (err) {
                err.res = res;
            }
            throw err;
        });
}

// 处理错误的返回信息(200)
export function filterData(res, options) {
    const { appendTip = '接口code不为0错误' } = options;
    if (res) {
        if (+res.code === 0) {
            return res.data;
        }
        // MCC
        if (Object.keys(res).length === 1) {
            return res;
        }
        // 这里兼容了针对PDA的错误处理
        let errorTip = (['string', 'number'].includes(typeof appendTip) ? appendTip : '');
        let msg = `${errorTip}${res.msg || res.error.msg || res.error.errMsg || res.error.message || ''}`;
        const error = new Error(msg);
        error.data = res;
        error.type = 'data';
        throw error;
    } else {
        const error = new Error(res);
        error.data = res;
        error.type = 'data';
        throw error;
    }
}

export function sendCatApi(url, code, responseTime) {
    // 不再上报Cat, 该有monitor统一上报时间和成功率
    // if (window.Owl) {
    //     try {
    //         let statusCode = code;

    //         if ([undefined, null].includes(statusCode)) {
    //             statusCode = 10001;
    //         } else if (+statusCode === 0) {
    //             statusCode = 10000;
    //         }

    //         window.Owl.addApi({
    //             name: url,
    //             statusCode,
    //             responseTime
    //         });
    //     } catch (e) {}
    // }
}

// 结果解析---------------------------------------------------
/**
 *
 * @param {*} url
 * @param {*} requestArgs
 * @param {*} options 添加接口cat上报的错误处理，options.catHandler,
 */
function wrapRequest(url, requestArgs, options) {
    if (requestArgs.headers['Content-Type'] && requestArgs.headers['Content-Type'].toLowerCase().includes('multipart/form-data')) {
        delete requestArgs.headers['Content-Type'];
    }
    let startTime = Date.now();
    let fetchResult = fetch(url, requestArgs)
        .then(res => {
            return filterStatus(res, url, Date.now() - startTime);
        })
        .then(res => {
            // 业务正常返回，上报业务状态码
            return parseJSON(res, url, Date.now() - startTime);
        });
    if (options.parseData !== false) {
        fetchResult = fetchResult.then(r => filterData(r, options));
    }
    return fetchResult.catch(e => {
        if (e.__status__ !== 'canceled') {
            // 上报 400-500错误
            sendCatApi(url, e.status, Date.now() - startTime);

            let catHandler = options.catHandler || (() => {});
            catHandler(url, e);
            throw e;
        }
    });
}

// 数据转换---------------------------------------------------
function toQueryString(body) {
    const qsUrl = {};
    Object.keys(body).forEach(key => {
        if (body[key] !== undefined) {
            qsUrl[key] = body[key];
        }
    });
    return queryStringify(qsUrl);
}

function toJSON(body) {
    return JSON.stringify(body);
}

function toForm(body) {
    if (body instanceof FormData) {
        return body;
    }
    const form = new FormData();
    Object.keys(body).forEach(k => {
        form.append(k, body[k]);
    });
    return form;
}

export function get({ url, params = {}, options = {} }) {
    const opts = parseRequestOptions(options);
    let urlParams = url.split('?')[1] || '';
    url = url.split('?')[0];
    try {
        urlParams = queryParse(urlParams);
    } catch (e) {
        console.error('request:get', urlParams, e);
    }
    urlParams = Object.assign(urlParams || {}, params);
    // 默认 trim 参数，但可以通过 isTrimParams 为 false 阻止 trim 行为
    const { isTrimParams = true } = options;
    if (isTrimParams) {
        trimParams(urlParams);
    }
    const queryString = toQueryString(urlParams);
    url += `${queryString ? '?' : ''}${queryString}`;

    const requestArgs = {
        method: 'GET',
        params,
        ...opts
    };
    return wrapRequest(url, requestArgs, options);
}

export function post({ url, body = {}, options = {} }) {
    const opts = parseRequestOptions(options);
    const { isTrimParams = true } = options;
    switch (true) {
        case opts.headers['Content-Type'].includes('application/json'):
            if (isTrimParams) {
                trimParams(body);
            }
            body = toJSON(body);
            break;
        case opts.headers['Content-Type'].includes('application/x-www-form-urlencoded'):
            body = toQueryString(body);
            break;
        case opts.headers['Content-Type'].includes('multipart/form-data'):
            body = toForm(body);
            break;
    }
    const requestArgs = {
        method: 'POST',
        body,
        ...opts
    };
    return wrapRequest(url, requestArgs, options);
}
